import { SUBSCRIPTIONS } from '@/clients'
import { laravelErrorHandler } from '@/helpers'
import { getAccessToken } from '@internetworkexpert/js-common'

const postCheckout = async payload => {
  const route = `checkout`
  try {
    const token = getAccessToken()
    if (token) {
      const headers = {
        Authorization: `Bearer ${token}`,
      }
      const { data } = await SUBSCRIPTIONS.post(route, payload, { headers })
      return data
    }
    const { data } = await SUBSCRIPTIONS.post(route, payload)
    return data
  } catch (errorObj) {
    const error = errorObj.response.data
    const { processor_error_code } = error
    if (error.new_user) {
      throw error
    }
    if (processor_error_code && processor_error_code.length) {
      throw error
    } else {
      throw laravelErrorHandler(errorObj)
    }
  }
}

const postNewTrial = async ({ payload, isAuthenticated }) => {
  const route = `free-tier`
  try {
    if (isAuthenticated) {
      const headers = {
        Authorization: `Bearer ${getAccessToken()}`,
      }
      const {
        data: { data },
      } = await SUBSCRIPTIONS.post(route, payload, { headers })
      return data
    }
    const {
      data: { data },
    } = await SUBSCRIPTIONS.post(route, payload)
    return data
  } catch (error) {
    throw laravelErrorHandler(error)
  }
}

const fetchSubscriptions = async () => {
  const route = `subscriptions`
  try {
    const {
      data: { data },
    } = await SUBSCRIPTIONS.get(route)
    return data
  } catch (error) {
    throw laravelErrorHandler(error)
  }
}

const fetchPaymentInfo = async () => {
  const route = `manage/account-information`
  try {
    const {
      data: { data },
    } = await SUBSCRIPTIONS.get(route)
    return data
  } catch (error) {
    throw laravelErrorHandler(error)
  }
}

const fetchCouponInfo = async payload => {
  const route = `coupon`
  try {
    const {
      data: { data },
    } = await SUBSCRIPTIONS.get(route, { params: { code: payload } })
    return data
  } catch (error) {
    throw laravelErrorHandler(error)
  }
}

export { postCheckout, postNewTrial, fetchSubscriptions, fetchPaymentInfo, fetchCouponInfo }
